import { RouterProvider } from "react-router-dom";
import Modal from "react-modal";
import { Slide, ToastContainer } from "react-toastify";

import router from "./routes";
import "./index.css";

Modal.setAppElement("#root");

const App = () => {
  return (
    <main>
      <RouterProvider router={router} />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
      />
    </main>
  );
};

export default App;
